import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import { ChangeEvent, useEffect, useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import EmojiPicker from 'components/base/EmojiPicker';
import { useChatContext } from 'providers/ChatProvider';
import ReactTextareaAutosize from 'react-textarea-autosize';
import AttachmentPreview from 'components/common/AttachmentPreview';
import { convertFileToAttachment } from 'helpers/utils';
import ImageAttachmentPreview from 'components/common/ImageAttachmentPreview';
import { faFaceSmile } from '@fortawesome/free-regular-svg-icons';
import {
  faImage,
  faMicrophone,
  faPaperPlane,
  faPaperclip
} from '@fortawesome/free-solid-svg-icons';
import { SENT_MESSAGE } from 'reducers/ChatReducer';
import { postSendMessage } from 'services/chatService';
import axios from 'axios';
import classNames from 'classnames';
import { useAuth } from 'providers/AuthProvider';

const ChatContentFooter = () => {
  const { currentConversation, chatDispatch } = useChatContext();
  const [messageText, setMessageText] = useState('');
  const [fileAttachment, setFileAttachment] = useState<File | null>(null);
  const [imageAttachments, setImageAttachments] = useState<File[]>([]);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const [audioFile, setAudioFile] = useState<File | null>(null); // Audio preparado para enviar
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(null);
  const API_URL = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  const miemValue = user?.iniciales || 'Sistema';
  // Manejo del contador
// Manejo del contador
useEffect(() => {
  let interval: NodeJS.Timeout;
  if (isRecording) {
    interval = setInterval(() => {
      setRecordingTime((prev) => prev + 1);
    }, 1000);
  } else {
    setRecordingTime(0);
  }
  return () => clearInterval(interval);
}, [isRecording]);

// Formateador de tiempo (00:00)
const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};


const startRecording = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    
    // 1. Intentar usar OGG/OPUS (el preferido de WhatsApp)
    let options = { mimeType: 'audio/ogg; codecs=opus' };
    
    // 2. Si el navegador (como Chrome en Windows) no soporta OGG, usará WebM/OPUS
    // Pero ojo: Meta a veces rechaza WebM. 
    if (!MediaRecorder.isTypeSupported(options.mimeType)) {
      options = { mimeType: 'audio/webm; codecs=opus' };
    }

    const recorder = new MediaRecorder(stream, options);
    const chunks: Blob[] = [];

    recorder.ondataavailable = (e) => chunks.push(e.data);
    recorder.onstop = () => {
      const audioBlob = new Blob(chunks, { type: 'audio/ogg; codecs=opus' });      // IMPORTANTE: El nombre del archivo debe terminar en .ogg
      const file = new File([audioBlob], "voice_note.ogg", { type: 'audio/ogg' });
      setAudioFile(file);
      stream.getTracks().forEach(track => track.stop());
    };

    recorder.start();
    setMediaRecorder(recorder);
    setIsRecording(true);
  } catch (err) {
    console.error("Error al grabar:", err);
  }
};


const sentMessage = async () => {
  if (!currentConversation) return;

  const hasContent = messageText || fileAttachment || imageAttachments.length > 0 || audioFile;
  if (!hasContent) return;

  const recipient = currentConversation.user.celular;

  if (!recipient) {
      console.error("No se puede enviar el mensaje: el destinatario no tiene un número de celular.");
      return; 
    }


  const conversationId = currentConversation.id;
  const personaId = currentConversation.user.id;


  // UI Local: Si hay audio, puedes simularlo o simplemente enviar el texto/imágenes primero
  chatDispatch({
    type: SENT_MESSAGE,
    payload: {
      conversationId,
      message: messageText || (audioFile ? "🎤 Nota de voz" : ""),
      attachments: {
        images: imageAttachments.map(img => URL.createObjectURL(img)),
        file: fileAttachment ? convertFileToAttachment(fileAttachment) : undefined
      }
    }
  });

  const textToSend = messageText;
  const imagesToSend = [...imageAttachments];
  const fileToSend = fileAttachment;
  const audioToSend = audioFile; // Referencia al audio

  // Limpiar todo
  setMessageText('');
  setImageAttachments([]);
  setFileAttachment(null);
  setAudioFile(null);

  try {
    if (textToSend) await postSendMessage(recipient, textToSend, miemValue); // <-- Enviamos el "miem" al backend

      // B. Enviar Imágenes si existen
      if (imagesToSend.length > 0) {
        for (const img of imagesToSend) {
          const formData = new FormData();
          formData.append('file', img);
          formData.append('phone', String(recipient));
          formData.append('type', 'image');
          formData.append('persona_id', String(personaId));
          formData.append('conversacion_id', String(conversationId));
          formData.append('miem', String(miemValue)); // <-- NUEVO
          await axios.post(`${API_URL}/whatsapps/send-media`, formData);
        }
      }

      // C. Enviar Documento si existe
      if (fileToSend) {
        const formData = new FormData();
        formData.append('file', fileToSend);
        formData.append('phone', String(recipient));
        formData.append('type', 'document');
        formData.append('persona_id', String(personaId));
        formData.append('conversacion_id', String(conversationId));
        formData.append('miem', String(miemValue)); // <-- NUEVO
        await axios.post(`${API_URL}/whatsapps/send-media`, formData);
      }


    // D. ENVIAR AUDIO
    if (audioToSend) {
      const formData = new FormData();
      formData.append('file', audioToSend);
      formData.append('phone', String(recipient));
      formData.append('type', 'audio');
      formData.append('persona_id', String(personaId));
      formData.append('conversacion_id', String(conversationId));
      formData.append('miem', String(miemValue)); // <-- NUEVO
      const res = await axios.post(`${API_URL}/whatsapps/send-media`, formData);
      if (res.data.success) {

// 1. Obtenemos la ruta que viene del backend (ej: "/uploads/audio/123.ogg")
    let finalPath = res.data.mensaje.body;

    // 2. Limpieza profunda: quitamos "public/" si existiera y aseguramos una sola barra inicial
    finalPath = finalPath.replace('public/', '');
    if (!finalPath.startsWith('/')) {
      finalPath = '/' + finalPath;
    }
    
    // 3. Eliminamos posibles duplicaciones de /uploads/uploads
    finalPath = finalPath.replace(/\/uploads\/uploads\//g, '/uploads/');

    chatDispatch({
      type: SENT_MESSAGE,
      payload: {
        conversationId,
        message: finalPath, 
        attachments: {}
      }
    });
      }
    }
  } catch (error) {
    console.error("Error al enviar:", error);
  }
};

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      sentMessage();
    }
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  return (
    <Card.Footer className="p-3">
{/* UI de Grabación Activa */}
  {isRecording && (
    <div className="d-flex align-items-center mb-2 text-danger fw-bold">
      <div className="dot-pulse me-2"></div> {/* Puedes añadir un CSS de punto parpadeante */}
      Grabando... {formatTime(recordingTime)}
    </div>
  )}

  {/* Vista previa del audio grabado pero NO enviado aún */}
  {audioFile && !isRecording && (
    <div className="mb-2 d-flex align-items-center bg-light p-2 rounded border border-translucent">
      <FontAwesomeIcon icon={faMicrophone} className="text-primary me-2" />
      <span className="fs-9 flex-1">Nota de voz lista para enviar</span>
      <Button variant="link" className="p-0 text-danger" onClick={() => setAudioFile(null)}>
        Borrar
      </Button>
    </div>
  )}


      {/* Previews de archivos antes del input */}
      {fileAttachment && (
        <div className="mb-2">
          <AttachmentPreview
            attachment={convertFileToAttachment(fileAttachment)}
            size="xl"
            handleRemove={() => setFileAttachment(null)}
          />
        </div>
      )}

      {imageAttachments.length > 0 && (
        <div className="mb-2 d-flex gap-2 flex-wrap">
          {imageAttachments.map((attachment, index) => (
            <ImageAttachmentPreview
              key={index}
              image={URL.createObjectURL(attachment)}
              handleClose={() => {
                setImageAttachments(prev => prev.filter((_, i) => index !== i));
              }}
            />
          ))}
        </div>
      )}

      <ReactTextareaAutosize
        minRows={1}
        maxRows={6}
        value={messageText}
        placeholder="Escribir acá (Ctrl + Enter para enviar)..."
        onChange={({ target: { value } }) => setMessageText(value)}
        onKeyDown={handleKeyDown}
        className="chat-textarea form-control outline-none border-0 scrollbar resize-none mb-2 p-0 fs-8 fw-normal"
      />

      <div className="d-flex gap-3 align-items-center">
        <EmojiPicker
          onSelect={selection => setMessageText(prev => prev + selection.emoji)}
        >
          <Button variant="link" className="p-0 text-body fs-9">
            <FontAwesomeIcon icon={faFaceSmile} />
          </Button>
        </EmojiPicker>

        {/* Botón Imágenes */}
        <div>
          <label className="text-body fs-9 cursor-pointer mb-0" htmlFor="images">
            <FontAwesomeIcon icon={faImage} />
          </label>
          <Form.Control
            className="d-none"
            type="file"
            accept="image/*"
            id="images"
            multiple
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              if (e.target.files) setImageAttachments(Array.from(e.target.files));
            }}
          />
        </div>

        {/* Botón Documentos */}
        <div>
          <label className="text-body fs-9 cursor-pointer mb-0" htmlFor="attachments">
            <FontAwesomeIcon icon={faPaperclip} />
          </label>
          <Form.Control
            className="d-none"
            type="file"
            id="attachments"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar"
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              if (e.target.files) setFileAttachment(e.target.files[0]);
            }}
          />
        </div>

    <Button 
      className={`p-0 fs-9 ${isRecording ? 'text-danger' : 'text-body'}`}
      onClick={isRecording ? stopRecording : startRecording}
    >
      <FontAwesomeIcon icon={faMicrophone} />
    </Button>

    <Button
      variant="primary"
      endIcon={<FontAwesomeIcon icon={faPaperPlane} className="ms-2" />}
      className="ms-auto"
      onClick={sentMessage}
    >
      Enviar
    </Button>

        
      </div>
    </Card.Footer>
  );
};

export default ChatContentFooter;